var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "forward",
  "use": "forward-usage",
  "viewBox": "0 0 15 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 15 11\" id=\"forward\">\n    <path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4.5 1.97 8.03 5.5 4.5 9.03M9.5 1.97l3.53 3.53L9.5 9.03\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol